export default "__VITE_ASSET__D12yLJxb__"